module.exports = __webpack_public_path__ + "static/media/undraw_dreamer_gxxi.fe75dbc1.svg";